import React from 'react';
import { IconContainer } from "./IconContainer.js";
export function IconTrailing(_ref) {
  var iconTrailing = _ref.iconTrailing;
  return iconTrailing ? /*#__PURE__*/React.createElement(IconContainer, {
    $position: "trailing"
  }, iconTrailing) : null;
}